export const TRANSLATION_KEYS = {
  NEXT_BUTTON: "SMART_MATCHING.BUTTON.NEXT_BUTTON",
  BACK_BUTTON: "SMART_MATCHING.BUTTON.BACK_BUTTON",
  START_SMART_MATCHING_BUTTON: "SMART_MATCHING.BUTTON.START_SMART_MATCHING_BUTTON",
  LOADING_TITLE: "SMART_MATCHING.LABELS.LOADING_TITLE",
  LOADING_DESCRIPTION: "SMART_MATCHING.LABELS.LOADING_DESCRIPTION",
  LOADING_COMPLETED_TITLE: "SMART_MATCHING.LABELS.LOADING_COMPLETED_TITLE",
  LOADING_COMPLETED_DESCRIPTION: "SMART_MATCHING.LABELS.LOADING_COMPLETED_DESCRIPTION",
  VIEW_RESULT_BUTTON: "SMART_MATCHING.BUTTON.VIEW_RESULT_BUTTON",
  SELECT_OPTION_PLACEHOLDER: "SMART_MATCHING.BUTTON.SELECT_OPTION_PLACEHOLDER",
  INTRODUCTION_TITLE: "SMART_MATCHING.INTRODUCTION.TITLE",
  INTRODUCTION_DESCRIPTION_1: "SMART_MATCHING.INTRODUCTION.DESCRIPTION_1",
  INTRODUCTION_DESCRIPTION_2: "SMART_MATCHING.INTRODUCTION.DESCRIPTION_2",
  QUESTION_GENDER_TITLE: "SMART_MATCHING.QUESTIONS.GENDER_TITLE",
  QUESTION_GENDER_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  QUESTION_GENDER_FEMALE: "SMART_MATCHING.QUESTIONS.GENDER_FEMALE",
  QUESTION_GENDER_MALE: "SMART_MATCHING.QUESTIONS.GENDER_MALE",
  QUESTION_VOICE_TITLE: "SMART_MATCHING.QUESTIONS.VOICE_TITLE",
  QUESTION_VOICE_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  QUESTION_VOICE_LOW: "SMART_MATCHING.QUESTIONS.VOICE_LOW",
  QUESTION_VOICE_MEDIUM: "SMART_MATCHING.QUESTIONS.VOICE_MEDIUM",
  QUESTION_VOICE_HIGH: "SMART_MATCHING.QUESTIONS.VOICE_HIGH",
  QUESTION_LANGUAGE_TITLE: "SMART_MATCHING.QUESTIONS.LANGUAGE_TITLE",
  QUESTION_LANGUAGE_LABEL: "SMART_MATCHING.QUESTIONS.LANGUAGE_LABEL",
  QUESTION_LANGUAGE_PLACEHOLDER: "SMART_MATCHING.QUESTIONS.LANGUAGE_PLACEHOLDER",
  QUESTION_PERSONALITY_TITLE: "SMART_MATCHING.QUESTIONS.PERSONALITY_TITLE",
  QUESTION_PERSONALITY_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  QUESTION_PERSONALITY_ENERGETIC: "SMART_MATCHING.QUESTIONS.PERSONALITY_ENERGETIC",
  QUESTION_PERSONALITY_KIND: "SMART_MATCHING.QUESTIONS.PERSONALITY_KIND",
  QUESTION_PERSONALITY_CALM: "SMART_MATCHING.QUESTIONS.PERSONALITY_CALM",
  QUESTION_PERSONALITY_SERIOUS: "SMART_MATCHING.QUESTIONS.PERSONALITY_SERIOUS",
  QUESTION_PERSONALITY_FUNNY: "SMART_MATCHING.QUESTIONS.PERSONALITY_FUNNY",
  QUESTION_PERSONALITY_EMPATHETIC: "SMART_MATCHING.QUESTIONS.PERSONALITY_EMPATHETIC",
  // Communication Style
  QUESTION_COMMUNICATION_STYLE_TITLE: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_TITLE",
  QUESTION_COMMUNICATION_STYLE_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  QUESTION_COMMUNICATION_STYLE_DIALOGUE_MANY_QUESTIONS: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_DIALOGUE_MANY_QUESTIONS",
  QUESTION_COMMUNICATION_STYLE_EASY_DELIVERY_FOCUSED: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_EASY_DELIVERY_FOCUSED",
  QUESTION_COMMUNICATION_STYLE_IMMEDIATE_FEEDBACK: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_IMMEDIATE_FEEDBACK",
  QUESTION_COMMUNICATION_STYLE_FREE_DIALOGUE: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_FREE_DIALOGUE",
  QUESTION_COMMUNICATION_STYLE_DISCUSSION_TYPE: "SMART_MATCHING.QUESTIONS.COMMUNICATION_STYLE_DISCUSSION_TYPE",
  // Lecture Type
  QUESTION_LECTURE_TYPE_TITLE: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_TITLE",
  QUESTION_LECTURE_TYPE_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  LECTURE_TYPE_QUESTION_CENTERED: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_QUESTION_CENTERED",
  LECTURE_TYPE_GRAMMAR_THEORY_CENTERED: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_GRAMMAR_THEORY_CENTERED",
  LECTURE_TYPE_REAL_LIFE_APPLICATION: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_REAL_LIFE_APPLICATION",
  LECTURE_TYPE_ASSIGNMENT_LEARNING_CENTERED: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_ASSIGNMENT_LEARNING_CENTERED",
  LECTURE_TYPE_FREE_TOPIC_DISCUSSION: "SMART_MATCHING.QUESTIONS.LECTURE_TYPE_FREE_TOPIC_DISCUSSION",
  // Lecture Material
  QUESTION_LECTURE_MATERIAL_TITLE: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_TITLE",
  QUESTION_LECTURE_MATERIAL_DESCRIPTION: "SMART_MATCHING.LABELS.CAN_SELECT_MULTIPLE",
  LECTURE_MATERIAL_PPT: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_PPT",
  LECTURE_MATERIAL_WORD_CARDS_TEXTBOOKS: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_WORD_CARDS_TEXTBOOKS",
  LECTURE_MATERIAL_WEB_ONLINE_CONTENT: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_WEB_ONLINE_CONTENT",
  LECTURE_MATERIAL_NOTES_HANDWRITTEN: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_NOTES_HANDWRITTEN",
  LECTURE_MATERIAL_VIDEO: "SMART_MATCHING.QUESTIONS.LECTURE_MATERIAL_VIDEO",
  // Error Page
  LOADING_ERROR_TITLE: "SMART_MATCHING.LABELS.LOADING_ERROR_TITLE",
  LOADING_ERROR_DESCRIPTION: "SMART_MATCHING.LABELS.LOADING_ERROR_DESCRIPTION",
  RETRY_BUTTON: "SMART_MATCHING.BUTTON.RETRY_BUTTON",
  // Skip Confirmation
  SKIP_CONFIRMATION_TITLE: "SMART_MATCHING.MODAL.SKIP_CONFIRMATION_TITLE",
  SKIP_CONFIRMATION_DESCRIPTION: "SMART_MATCHING.MODAL.SKIP_CONFIRMATION_DESCRIPTION",
  SKIP_CONFIRMATION_YES: "BUTTON.YES",
  SKIP_CONFIRMATION_NO: "BUTTON.NO",
};

export const DEFAULT_TRANSLATIONS = {
  nextButton: "다음",
  backButton: "뒤로가기",
  startSmartMatchingButton: "스마트 매칭 시작하기",
  loadingTitle: "매칭 중입니다...",
  loadingDescription: "학습자에게 알맞은 튜터를 찾고 있어요. 잠시만 기다려 주세요.",
  loadingCompletedTitle: "매칭이 완료되었습니다.",
  loadingCompletedDescription: "스마트 매칭을 위한 분석을 모두 마쳤어요. 스마트 매칭 결과에 맞는 강사와 강의를 보여드릴게요.",
  viewResultButton: "결과 보기",
  selectOptionPlaceholder: "구사 가능 언어",
  introductionTitle: "스마트 매칭을 시작합니다.",
  introductionDescription1: "스마트 매칭은 중간 단계에서 답변 생략이 가능하며, 답변 생략 시 사용자의 사용 패턴에 따라 추천해 드립니다.",
  introductionDescription2: "단, 중간 단계에서 종료 시 이전 답변들은 저장 되지 않습니다.",
  questionGenderTitle: "선호하는 강사의 성별은?",
  questionGenderDescription: "중복선택가능합니다.",
  questionGenderFemale: "여성",
  questionGenderMale: "남성",
  questionVoiceTitle: "선호하는 강사의 목소리 톤은?",
  questionVoiceDescription: "중복선택가능합니다.",
  questionVoiceLow: "저음",
  questionVoiceMedium: "중음",
  questionVoiceHigh: "고음",
  questionLanguageTitle: "선호하는 강사의 구사 가능 언어는?",
  questionLanguageLabel: "구사 가능 언어",
  questionLanguagePlaceholder: "대한민국",
  questionPersonalityTitle: "선호하는 강사 성격은?",
  questionPersonalityDescription: "중복선택가능합니다.",
  questionPersonalityEnergetic: "밝고 에너지가 넘치는",
  questionPersonalityKind: "친절하고 인내심 많은",
  questionPersonalityCalm: "부드럽고 차분한",
  questionPersonalitySerious: "진지하고 집중력을 높여주는",
  questionPersonalityFunny: "재미있고 유머감각이있는",
  questionPersonalityEmpathetic: "공감 능력이 뛰어나고따뜻한",
  // Communication Style
  questionCommunicationStyleTitle: "의사소통 스타일은?",
  questionCommunicationStyleDescription: "의사소통 스타일에 대한 설명입니다.",
  questionCommunicationStyleDialogueManyQuestions: "질문이 많은 대화형",
  questionCommunicationStyleEasyDeliveryFocused: "쉬운 전달 중심",
  questionCommunicationStyleImmediateFeedback: "즉각적인 피드백",
  questionCommunicationStyleFreeDialogue: "자유로운 대화형",
  questionCommunicationStyleDiscussionType: "토론형",
  // Lecture Type
  questionLectureTypeTitle: "강의 유형은?",
  questionLectureTypeDescription: "강의 유형에 대한 설명입니다.",
  lectureTypeQuestionCentered: "중심에 집중된 강의",
  lectureTypeGrammarTheoryCentered: "문법 이론에 중심을 둔 강의",
  lectureTypeRealLifeApplication: "실생활에 적용되는 강의",
  lectureTypeAssignmentLearningCentered: "과제 학습에 중심을 둔 강의",
  lectureTypeFreeTopicDiscussion: "자유 주제 토론을 통한 강의",
  // Lecture Material
  questionLectureMaterialTitle: "강의 자료는?",
  questionLectureMaterialDescription: "강의 자료에 대한 설명입니다.",
  lectureMaterialPPT: "PPT",
  lectureMaterialWordCardsTextbooks: "단어 카드와 교과서",
  lectureMaterialWebOnlineContent: "온라인 컨텐츠",
  lectureMaterialNotesHandwritten: "직접 쓴 노트",
  lectureMaterialVideo: "동영상",
  // Error Page
  loadingErrorTitle: "오류가 발생했습니다.",
  loadingErrorDescription: "다시 시도해 주세요.",
  retryButton: "다시 시도",
  // Skip Confirmation
  skipConfirmationTitle: "질문을 건너뛰시겠습니까?",
  skipConfirmationDescription: "선택하지 않으면 모든 옵션이 고려됩니다.",
  skipConfirmationYes: "예",
  skipConfirmationNo: "아니오",
};

export const getTranslationKeysArray = () => Object.values(TRANSLATION_KEYS); 